import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';
import { provideRouter, Routes, withRouterConfig } from '@angular/router';

export function provideAppRoutingAndHttp(routes: Routes): (Provider | EnvironmentProviders)[] {
  return [
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ];
}
